"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _helpers = require("./../utils/helpers");

var usePrice = function usePrice() {
  var normalizePrice = function normalizePrice(a) {
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : a;

    if (a !== b) {
      return "".concat((0, _helpers.formatMoney)(a), " - ").concat((0, _helpers.formatMoney)(b));
    } else {
      return (0, _helpers.formatMoney)(a);
    }
  };

  return {
    normalizePrice: normalizePrice
  };
};

var _default = usePrice;
exports.default = _default;